import {ClusterEventCount} from 'types/geo';

import {eventColor} from './meta';

export function markerSvg(events: ClusterEventCount[], size: number) {
    const segments = events.filter(
        (event) => Number.isFinite(event.eventsCount) && event.eventsCount > 0,
    );
    const total = segments.reduce((sum, event) => sum + event.eventsCount, 0);
    let offset = 0;
    const sectors: string[] = [];
    const ring = segments
        .map((event) => {
            const length = (event.eventsCount / total) * 100;
            const circle = `<circle cx="24" cy="24" r="20" fill="none" stroke="${eventColor(
                event.eventKind,
            )}" stroke-width="8" pathLength="100" stroke-dasharray="${length} ${100 -
                length}" stroke-dashoffset="${-offset}" transform="rotate(-90 24 24)" opacity="0.15"/>`;
            if (segments.length > 1) {
                const point = (percent: number) => {
                    const angle = (percent / 100) * Math.PI * 2 - Math.PI / 2;
                    return `${24 + 18 * Math.cos(angle)} ${24 + 18 * Math.sin(angle)}`;
                };
                sectors.push(
                    `<path d="M 24 24 L ${point(offset)} A 18 18 0 ${length > 50 ? 1 : 0} 1 ${point(
                        offset + length,
                    )} Z" fill="${eventColor(event.eventKind)}"/>`,
                );
            }
            offset += length;
            return circle;
        })
        .join('');
    const color = segments.length === 1 ? eventColor(segments[0].eventKind) : '#0f172b';
    const fill = sectors.length
        ? sectors.join('')
        : `<circle cx="24" cy="24" r="18" fill="${color}"/>`;
    return `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 48 48">${ring}${fill}<circle cx="24" cy="24" r="18" fill="none" stroke="white" stroke-width="2"/></svg>`;
}
